import React from "react";
import styles from "./Label.module.css";

const Label = ({ 
  children, 
  className = "",
  htmlFor = "",
  required = false 
}) => {
  const labelClass = `${styles.label} ${className}`;

  return (
    <label 
      htmlFor={htmlFor}
      className={labelClass}
    >
      {children}
      {required && <span className={styles.required}> *</span>}
    </label>
  );
};

export default Label;
